import React, { useCallback, useState } from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'

import Input from '../../../../components/Form/Input'

import Select from '../../../../components/Form/Select'

import { ComponentTitle } from '../../styles'
import { ContainerButton } from './styles'
import { BoxContainer, Button, Typography } from '../../../../components'
import { Form, FormBody } from '../../../../components/Form/styles'
import { ecbrAdminRoleListForSelect } from '../../../../constants/roles'
import ecbrApi from '../../../../services/ecbrApi'
import ErrorMessage from '../../../../components/Form/ErrorMessage'
import { UserEvents } from '../constants'
import { extractErrorMessage } from '../../../../helpers/extractErrorMessage'
import { AlertModal } from '../../../../modals/AlertModal'
import { useModal } from '../../../../hooks/useModal'
import { ModalBodyContainer } from '../../../../modals/styles'

const initialValues = {
  name: '',
  email: '',
  role: ''
}

const formSchema = Yup.object().shape({
  name: Yup.string().required('Campo obrigatório'),
  email: Yup.string().required('Campo obrigatório').email('Email inválido'),
  role: Yup.string()
    .transform((_, obj) => obj?.value ?? undefined)
    .required('Campo obrigatório')
})

const SendInvites = ({ eventListener }) => {
  const [error, setError] = useState('')
  const [alertModal, openAlertModal] = useModal(AlertModal)

  const openAlert = useCallback(
    (txt) =>
      openAlertModal({
        title: `Dados salvos!`,
        body: (
          <ModalBodyContainer>
            <Typography type="text" color="#7D7987">
              {txt}
            </Typography>
          </ModalBodyContainer>
        )
      }),
    [openAlertModal]
  )

  const onSubmit = useCallback(
    async (values, { setSubmitting, resetForm }) => {
      try {
        setError('')
        setSubmitting(true)
        const { role, ...rest } = values
        const data = {
          ...rest,
          role: role.value
        }
        await ecbrApi.userInvites.invite(data)
        resetForm()
        eventListener?.publish(UserEvents.INVITE_SENT)
        setSubmitting(false)
        openAlert('Convite enviado com sucesso!')
      } catch (err) {
        const errorMessage = extractErrorMessage(err, 'Erro ao enviar convite')
        setError(errorMessage)
        setSubmitting(false)
      }
    },
    [eventListener, openAlert]
  )

  return (
    <BoxContainer>
      {alertModal}
      <ComponentTitle>Enviar convites</ComponentTitle>

      <Formik
        initialValues={initialValues}
        validationSchema={formSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting }) => (
          <Form maxWidth="100%" margin="0">
            <FormBody type="flex" justifyContent="flex-start" flexRow>
              <Input
                name="name"
                label="Nome de usuário"
                showValidIcon
                display="inline-block"
                width="330px"
                fontSizeLabel="12px"
              />
              <Input
                name="email"
                label="E-mail de acesso"
                display="inline-block"
                width="319px"
                fontSizeLabel="12px"
              />
              <Select
                name="role"
                label="Perfil"
                options={ecbrAdminRoleListForSelect}
                optionValue="value"
                optionLabel="label"
                width="230px"
                fontSizeLabel="12px"
              />
              <ContainerButton>
                <Button
                  text={isSubmitting ? 'Enviando...' : 'Enviar convite'}
                  type="submit"
                  variant="primary"
                  width="120px"
                  disabled={isSubmitting}
                />
              </ContainerButton>
            </FormBody>
            <ErrorMessage>{error}</ErrorMessage>
          </Form>
        )}
      </Formik>
    </BoxContainer>
  )
}

export default SendInvites
